export default __webpack_public_path__ + "static/media/sidebar_sicknotes.62f059e8.svg";